export function normalizeNotificationProductId(value: unknown): number | null {
  const id = typeof value === 'number' ? value : Number(value)
  return Number.isInteger(id) && id > 0 ? id : null
}

export function resolveNotificationProductId(notification: { product_id?: unknown; message?: string; type?: string }): number | null {
  const explicitId = normalizeNotificationProductId(notification.product_id)
  if (explicitId !== null) return explicitId

  if (notification.type !== 'payment' && notification.type !== 'payment_failed') {
    return null
  }

  const match = notification.message?.match(/\blot\s+#?(\d+)\b/i)
  return normalizeNotificationProductId(match?.[1])
}
